import { Controller } from "@hotwired/stimulus"

// History-back controller: replaces `onclick="gHistoryBack()"` style cancel
// links. Falls back to a `data-fallback-value="/path"` if there is no
// history entry to go back to (first navigation, or a Turbo cold visit).
//
// Usage:
//   = link_to "Cancel", "#",
//       data: {
//         controller: "history-back",
//         action: "click->history-back#back",
//         history_back_fallback_value: apps_path,
//       }
export default class extends Controller {
  static values = { fallback: String }

  back(event) {
    event.preventDefault()
    if (window.history.length > 1) {
      window.history.back()
    } else if (this.hasFallbackValue) {
      window.location.href = this.fallbackValue
    }
  }
}
